import { NewContract } from '@vae/server/dist/client'
import React from 'react'
import EmailInput from '../../../components/inputs/EmailInput'
import PhoneInput from '../../../components/inputs/PhoneInput'
import StringInput from '../../../components/inputs/StringInput'
import { useTranslation } from 'react-i18next'

const CustomerDetailsStep: React.FC<{
	contract: Partial<NewContract>
	setContract: (key: keyof NewContract, value: string | number) => void
	nameNeeded: boolean
	ssnNeeded: boolean
}> = ({ contract, setContract, nameNeeded, ssnNeeded }) => {
	const { t } = useTranslation('modals_createContract', { keyPrefix: 'customerDetailsStep' })

	const name = `${contract.firstName ?? ''} ${contract.lastName ?? ''}`.trim()
	const ssn = contract.ssn ?? ''

	return (
		<div className='container'>
			{nameNeeded ? (
				<>
					<StringInput
						label={t('firstName')}
						value={contract.firstName ?? ''}
						onChange={v => setContract('firstName', v)}
					/>
					<StringInput
						label={t('lastName')}
						value={contract.lastName ?? ''}
						onChange={v => setContract('lastName', v)}
					/>
				</>
			) : (
				<StringInput readonly={true} value={name} label={t('name')} />
			)}

			{ssnNeeded ? (
				<StringInput
					label={t('ssn')}
					value={contract.ssn ?? ''}
					onChange={v => setContract('ssn', v)}
				/>
			) : (
				<StringInput readonly={ssnNeeded} value={ssn} label={t('ssn')} />
			)}

			<EmailInput value={contract?.email ?? ''} onChange={v => setContract('email', v)} />

			<PhoneInput value={contract?.phone ?? ''} onChange={v => setContract('phone', v)} />

			<StringInput
				value={contract?.recommenderEmail ?? ''}
				label={t('recommenderEmail')}
				onChange={v => setContract('recommenderEmail', v)}
			/>
		</div>
	)
}

export default CustomerDetailsStep
